import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import Iconify from '../../../theme/iconify/iconify';

function File({ file, user, download, visibility, remove }) {
    const { t } = useTranslation();

    return (
        <Grid container key={file._id} sx={{
            borderRadius: '8px',
            p: 1,
            mb: 1,
            border: '1px solid rgba(33, 43, 54, 0.08)',
            '&:hover': {
                backgroundColor: 'rgba(33, 43, 54, 0.02)'
            }
        }}>
            <Grid item md={0.5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Avatar
                    id='mISLec_avatar_icon'
                    alt='PDF icon'
                    src='/assets/icons/pdf.png'
                    sx={{
                        width: 30,
                        height: 30
                    }}
                />
            </Grid>
            <Grid item md={10} sx={{ pl: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column', textAlign: 'left' }}>
                <Typography variant='h6' sx={{ fontSize: '0.95rem !important', width: '100%', overflowWrap: 'break-word', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {file.filename.replace(/\.[^/.]+$/, '')}
                </Typography>
                <Typography variant='caption' sx={{ fontSize: '0.7rem !important', color: 'text.secondary' }}>
                    {file.filename.split('.').pop().toUpperCase()} | {(file.size / (1024 * 1000)).toFixed(2)} MB
                </Typography>
            </Grid>
            <Grid item md={1.5} sx={{ pr: 0.5, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Tooltip title={t('course.tooltips.downloadMaterial')} arrow>
                    <IconButton
                        onClick={() => download(file)}
                        sx={{
                            p: 0.5,
                            borderRadius: '8px'
                        }}
                    >
                        <Iconify icon='material-symbols:download' width={20} />
                    </IconButton>
                </Tooltip>
                {user && user?.role !== 'student' &&
                    <>
                        <Divider orientation='vertical' flexItem sx={{ mx: '4px', my: '10px' }} />
                        <Tooltip title={t(`course.tooltips.${file?.visible ? 'hide' : 'show'}Material`)} arrow>
                            <IconButton
                                onClick={() => visibility(file)}
                                sx={{
                                    p: 0.5,
                                    borderRadius: '8px'
                                }}
                            >
                                <Iconify icon={file?.visible ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={t('course.tooltips.removeMaterial')} arrow>
                            <IconButton
                                color='error'
                                onClick={() => remove(file)}
                                sx={{
                                    p: 0.5,
                                    borderRadius: '8px'
                                }}
                            >
                                <Iconify icon='eva:trash-outline' width={17} />
                            </IconButton>
                        </Tooltip>
                    </>
                }
            </Grid>
        </Grid>
    );
}

export default File;